import type { FC } from "react";

import { INDEX_NOT_FOUND } from "components/constants";
import {
  INTERACTION_MODE_ICONS,
  PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE,
  PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW,
} from "components/materials/page/interaction-mode/helpers";
import { InteractionMode, type PageType } from "components/server-types";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { ChevronDownIcon } from "mds/icons";
import { isGroupPage } from "utils/page-utils";

type InteractionModeIconTextProps = {
  page: PageType;
  pageGroupIndex?: number;
  includeChevron?: boolean;
};

export const InteractionModeIconText: FC<InteractionModeIconTextProps> = ({
  page,
  pageGroupIndex = INDEX_NOT_FOUND,
  includeChevron = false,
}) => {
  const mode = page.interaction_mode;

  let text: string;
  let shortText: string | undefined;

  if (isGroupPage(page) && pageGroupIndex !== INDEX_NOT_FOUND) {
    text = t("common.group_title", { number: pageGroupIndex + 1 });
  } else if (mode === InteractionMode.SHARED_CLASS) {
    text = t("page_interaction_mode_menu.interaction_mode.all");
    shortText = t("page_interaction_mode_menu.interaction_mode.all_short");
  } else {
    text = t(`page_interaction_mode_menu.interaction_mode.${mode}`);
  }

  return (
    <IconText
      containerQueryClassNameHide={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE}
      containerQueryClassNameShow={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW}
      iconEnd={includeChevron ? <ChevronDownIcon /> : undefined}
      iconStart={INTERACTION_MODE_ICONS[mode]}
      shortText={shortText}
      text={text}
    />
  );
};
